import {
  A11y as SwiperA11y,
  Navigation as SwiperNavigation,
} from 'swiper/modules';
import { Swiper } from 'swiper/react';
import { A11yOptions, SwiperModule } from 'swiper/types';

import styles from './brands-block.module.scss';

import 'swiper/css';
import 'swiper/css/navigation';

type SwiperContentProps = {
  ariaLabelNext?: string;
  ariaLabelPrevious?: string;
  children: React.ReactNode;
};

export const SwiperContent: React.FC<SwiperContentProps> = ({
  ariaLabelNext,
  ariaLabelPrevious,
  children,
}) => {
  const SwiperModules: SwiperModule[] = [SwiperA11y, SwiperNavigation];

  const a11y: A11yOptions = {
    nextSlideMessage: ariaLabelNext,
    prevSlideMessage: ariaLabelPrevious,
  };

  return (
    <Swiper
      a11y={a11y}
      allowTouchMove
      className={styles['swiper']}
      effect={'slide'}
      modules={SwiperModules}
      navigation={true}
      slidesPerView={'auto'}
      speed={1000}
    >
      {children}
    </Swiper>
  );
};

export default SwiperContent;
